import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c824f10c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c824f10c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c824f10c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c824f10c')) {
      api.createRecord('c824f10c', component.options)
    } else {
      api.reload('c824f10c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c824f10c&scoped=true", function () {
      api.rerender('c824f10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workShop/index.vue"
export default component.exports